const STORAGE_KEY = 'line.animatedTurnIds.v1'
const MAX_TRACKED_IDS = 500

const readStorage = (): string[] => {
  if (typeof window === 'undefined' || !window.localStorage) return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.filter((entry): entry is string => typeof entry === 'string') : []
  } catch {
    return []
  }
}

const animated = new Set<string>(readStorage())

const persist = () => {
  if (typeof window === 'undefined' || !window.localStorage) return
  try {
    const trimmed = animated.size > MAX_TRACKED_IDS
      ? [...animated].slice(animated.size - MAX_TRACKED_IDS)
      : [...animated]
    if (trimmed.length !== animated.size) {
      animated.clear()
      trimmed.forEach((id) => animated.add(id))
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
  } catch {
    /* localStorage full or blocked — animation set stays in-memory only */
  }
}

export const hasBeenAnimated = (turnId: string | undefined): boolean =>
  Boolean(turnId) && animated.has(turnId as string)

export const markAnimated = (turnId: string | undefined) => {
  if (!turnId || animated.has(turnId)) return
  animated.add(turnId)
  persist()
}
